// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#eb5757","bgColor":"white","flex":"d_m","layout":"d_n","header":"d_g","title":"d_p","content":"d_l","footer":"d_q"};